import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=7f6efa8a&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=ts"
export * from "./coupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6efa8a",
  null
  
)

export default component.exports